export const STAGE_STATUS = {
    to_do: 'to_do',
    in_progress: 'in_progress',
    in_review: 'in_review',
    success: 'success',
};

export const ORDERED_STATUSES = [
    STAGE_STATUS.to_do,
    STAGE_STATUS.in_progress,
    STAGE_STATUS.in_review,
    STAGE_STATUS.success,
];

export const STAGE_STATUS_LABEL = {
    [STAGE_STATUS.to_do]: 'Your To Do',
    [STAGE_STATUS.in_progress]: 'With DiviUp',
    [STAGE_STATUS.in_review]: 'Your Review',
    [STAGE_STATUS.success]: 'Completed',
};

export const STAGE_TYPE = {
    clear_picture: 'clear_picture',
    realistic_design: 'realistic_design',
    ai_ify: 'ai_ify',
    feedback: 'feedback',
    team_rollout: 'team_rollout',
};

export const STAGE_TYPE_LABEL = {
    [STAGE_TYPE.clear_picture]: 'Clear Picture',
    [STAGE_TYPE.realistic_design]: 'Realistic Design',
    [STAGE_TYPE.ai_ify]: 'AI-ify',
    [STAGE_TYPE.feedback]: 'Feedback',
    [STAGE_TYPE.team_rollout]: 'Team Rollout',
};

export const STAGE_TYPE_OPTIONS = Object.values(STAGE_TYPE).map((type) => ({
    id: type,
    name: STAGE_TYPE_LABEL[type],
}));

// used for form rendering
export const CONTENT_DETAIL_KEY = {
    [STAGE_TYPE.clear_picture]: {
        [STAGE_STATUS.to_do]: 'questionnaire',
        [STAGE_STATUS.in_review]: 'solution_overview',
    },
    [STAGE_TYPE.realistic_design]: {
        [STAGE_STATUS.in_review]: 'solution_outline',
    },
    [STAGE_TYPE.ai_ify]: {
        // [STAGE_STATUS.in_review]: 'implementation_config',
    },
    [STAGE_TYPE.feedback]: {
        [STAGE_STATUS.to_do]: 'testing_plan',
        [STAGE_STATUS.in_review]: 'suggestions',
    },
    [STAGE_TYPE.team_rollout]: {
        [STAGE_STATUS.in_review]: 'rollout_plan',
    },
};

export const SUBMIT_BUTTON_LABEL = {
    [STAGE_TYPE.clear_picture]: {
        [STAGE_STATUS.to_do]: 'Submit Questionnaire',
        [STAGE_STATUS.in_review]: 'Approve Overview',
    },
    [STAGE_TYPE.realistic_design]: {
        [STAGE_STATUS.in_review]: 'Approve Design',
    },
    [STAGE_TYPE.feedback]: {
        [STAGE_STATUS.to_do]: 'Submit Feedback',
        [STAGE_STATUS.in_review]: 'Approve Suggestions',
    },
    [STAGE_TYPE.team_rollout]: {
        [STAGE_STATUS.in_review]: 'Approve Plan',
    },
};

const ALLOWED_STAGE_STATUSES = {
    [STAGE_TYPE.clear_picture]: [
        STAGE_STATUS.to_do,
        STAGE_STATUS.in_progress,
        STAGE_STATUS.in_review,
        STAGE_STATUS.success,
    ],
    [STAGE_TYPE.realistic_design]: [
        STAGE_STATUS.in_progress,
        STAGE_STATUS.in_review,
        STAGE_STATUS.success,
    ],
    [STAGE_TYPE.ai_ify]: [STAGE_STATUS.in_progress, STAGE_STATUS.success],
    [STAGE_TYPE.feedback]: [
        STAGE_STATUS.to_do,
        STAGE_STATUS.in_progress,
        STAGE_STATUS.in_review,
        STAGE_STATUS.success,
    ],
    [STAGE_TYPE.team_rollout]: [STAGE_STATUS.to_do, STAGE_STATUS.in_progress, STAGE_STATUS.success],
};

export const CONTENT_GROUP_TYPE = {
    form: 'form',
    diagram: 'diagram',
    text: 'text',
    requirements: 'requirements',
    variables: 'variables',
    steps: 'steps',
    tags: 'tags',
};

export const CONTENT_GROUP_TYPES_WITH_EDITING = [
    CONTENT_GROUP_TYPE.form,
    CONTENT_GROUP_TYPE.requirements,
    CONTENT_GROUP_TYPE.variables,
    CONTENT_GROUP_TYPE.steps,
];

export const CONTENT_GROUP_TYPES_WITH_SORTING = [
    CONTENT_GROUP_TYPE.form,
    CONTENT_GROUP_TYPE.requirements,
    CONTENT_GROUP_TYPE.variables,
    CONTENT_GROUP_TYPE.steps,
    CONTENT_GROUP_TYPE.tags,
];

export const CONTENT_GROUP_DETAIL_KEY = {
    [CONTENT_GROUP_TYPE.form]: 'inputs',
    [CONTENT_GROUP_TYPE.requirements]: 'requirements',
    [CONTENT_GROUP_TYPE.variables]: 'variables',
    [CONTENT_GROUP_TYPE.steps]: 'steps',
    [CONTENT_GROUP_TYPE.tags]: 'tag_groups',
    [CONTENT_GROUP_TYPE.text]: 'text',
    [CONTENT_GROUP_TYPE.diagram]: 'diagram',
};
